<template>
  <Poptip  trigger="hover"  popper-class="hover-card" :width="238" placement="right-start">
    <IndexCard :img="card.coverUrl" :name="card.authorName" :office="card.lawOrMarketExpansionName" :times="card.countView" @click="preview(card)">
      <template #operator>
        <Dropdown trigger="click">
          <VuiButton :class="['btn', {'disable': !isBindAlpha && isLogin}]" type="warning" @click="clickBtnHanlder($event)">
            <Icon type="md-lock" />
            立即下载
          </VuiButton>
          <template #list>
            <DropdownMenu>
              <DropdownItem v-for="item in card.marketExpansionCoursesDTOS" :key="item.id" @click.stop.native="clickExpandHandler(item)">{{ item.name }}</DropdownItem>
            </DropdownMenu>
          </template>
        </Dropdown>
      </template>
    </IndexCard>
    <div class="card" slot="content">
      <h3 class="card__title" v-html="card.name"></h3>
      <div v-if="card.marketExpansionTypeName" class="card__tag">{{  card.marketExpansionTypeName  }}</div>
      <div v-if="card.marketExpansionSubjectTypeName" class="card__tag">{{  card.marketExpansionSubjectTypeName  }}</div>
      <div class="card__authors">
        <div v-for="author in card.authorInfo" :key="author.id" class="card__author">
          <img class="card__avatar" :src="author.authorAvatar" />
          <div class="card__author-detail">
            <div class="card__name">{{ author.authorName }}</div>
            <div class="card__office">{{ author.lawName }}</div>
          </div>
        </div>
      </div>
      <p class="card__desc">课件简介：<span v-html="card.remark"></span></p>
      <div class="card__btn" @click="preview(card)">查看详情 <Icon type="ios-arrow-forward" /></div>
    </div>
  </Poptip>
</template>

<script>
import api from '@/api/home.js'
import IndexCard from './IndexCard.vue'
export default {
  name: 'ExpandCard',
  components: {
    IndexCard,
  },
  props: {
    card: Object,
    isLogin: Boolean,
    isBindAlpha: Boolean,
  },
  data () {
    return {
      contentVisible: false,
    }
  },
  methods: {
    preview (expand) {
      if (this.isLogin) {
        if (this.isBindAlpha) {
          let { href } = this.$router.resolve({
            name: 'ExpandPreview',
            params: {
              id: expand.id,
            },
          })
          window.open(href, '_blank')
        } else {
          this.$store.commit('app/setDrainagePopVisible', { flag: true, enableSign: 0 })
        }
      } else {
        this.$Message.error('请先登录')
        this.$router.push({ name: 'Login' })
      }
    },
    clickBtnHanlder (e) {
      if (!this.isBindAlpha && this.isLogin) {
        e.stopPropagation()
        this.$store.commit('app/setDrainagePopVisible', { flag: true, enableSign: 0 })
      }
    },
    clickExpandHandler (item) {
      if (this.isLogin) {
        if (this.isBindAlpha) {
          if (item.fileUrl) {
            api.downloadExpand(item.id)().then(res => {
              if (res) {
                let file = JSON.parse(item.fileUrl)
                let a = document.createElement('a')
                a.href = file.fileUrl
                a.download = file.fileName
                a.click()
              }
            })
          } else {
            this.$Message.error('暂无可下载的地址')
          }
        } else {
          this.$store.commit('app/setDrainagePopVisible', { flag: true, enableSign: 0 })
        }
      } else {
        this.$Message.error('请先登录')
        this.$router.push({ name: 'Login' })
      }
    },
  },
}
</script>
